// Refined status chip system with 7 tones and a leading indicator dot
export const STATUS_TONE = {
  // Success (deep emerald)
  approved: "sage", accepted: "sage", paid: "sage", confirmed: "sage",
  completed: "sage", live: "sage", delivered: "sage", replacement_delivered: "sage",
  fully_signed: "sage", exchange_approved: "sage", ok: "sage",
  order_confirmed: "sage", payment_confirmed: "sage", fully_received: "sage",
  active: "sage",

  // Info (charcoal blue) - progress
  draft: "denim", approval_pending: "denim", pending: "denim",
  in_production: "denim", material_planning: "denim", cutting_started: "denim",
  stitching_started: "denim", quality_check: "denim", packaging_in_progress: "denim",
  packed: "denim", ready_for_dispatch: "denim", dispatch_scanned: "denim",
  supplier_confirmed: "denim", partially_received: "denim", sent_to_supplier: "denim",
  order_placed: "denim", material_issued: "denim",

  // Warning (amber)
  shipped: "gold", in_transit: "gold", out_for_delivery: "gold", reached_hub: "gold",
  exchange_requested: "gold", partially_signed: "gold", coming_soon: "gold",
  sent_for_signature: "gold", internal_review: "gold", changes_requested: "gold",
  approved_for_signing: "gold", viewed: "gold", material_shortage: "gold",

  // Destructive (red)
  cancelled: "rose", rejected: "rose", exchange_rejected: "rose",
  delivery_delayed: "rose", address_issue: "rose",
  customer_unavailable: "rose", on_hold: "rose", out_of_stock: "rose",
  failed: "rose", declined: "rose", expired: "rose", terminated: "rose",
  partially_rejected: "rose",

  // Neutral
  archived: "taupe", closed: "taupe", read_only: "taupe",

  // Accent lavender for special
  quality_check_pending: "lavender", alteration_required: "lavender",
  invoice_pending: "lavender", payment_pending: "lavender", partially_paid: "lavender",
};

export default function StatusChip({ value, className = "" }) {
  if (!value) return null;
  const tone = STATUS_TONE[value] || "taupe";
  const label = String(value).replace(/_/g, " ");
  const readable = label.charAt(0).toUpperCase() + label.slice(1);
  return (
    <span className={`status-chip chip-${tone} ${className}`} data-testid={`status-${value}`}>
      <span className="w-1.5 h-1.5 rounded-full bg-current opacity-80" />
      {readable}
    </span>
  );
}
